nc_initScrollClass('.header', '.header-addon-top', 'fixed');

$(window).load(function () {
    // Variable für das fixierte Element
    var fixedElement = $('.header');
    // Nimmt die Höhe aller vorherigen Elemente von fixedElement und verschiebt diesen um den Wert nach unten.
    fixedElement.css('top', fixedElement.prev().outerHeight(true) + 'px');
});

$(document).ready(sliderCaptionMargin);
$(window).on('resize',sliderCaptionMargin);

function sliderCaptionMargin() {
    var fixedElements = $('.header');
    $('.slider .carousel-caption').css({'margin-top': fixedElements.outerHeight(true) + fixedElements.prev().outerHeight(true) + 60 + 'px'});
}